<template>
  <div class="Solution">
    <div class="page_img">
      <img src="@/assets/img/solution.jpg" alt="">
    </div>
    <div class="content1 flex_row page_content">
      <div class="content_title summary_top">
        <img class="back_left back_left1" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right back_right1" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="page_summary font_shadow" style="font-size: 0.3rem">解决方案</div>
      </div>
    </div>
    <div class="content">
      <div class="solution_main">
        <img src="@/assets/img/solution_main.jpg" alt="">
      </div>
      <div class="solution_footer">
        <div class="solution_item" v-for="item in  list">
          <div class="item">
            <div class="solution_title">{{item}}</div>
          </div>
          <div class="solution_line">
            <span class="left"></span>
            <div class="line"></div>
            <span class="right"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column operate_title">
        <div class="operate_summary">智慧眼健康中心运营系统</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
    </div>
    <div class="operate_back"><img src="@/assets/img/solution_back1.png" alt=""></div>
    <div class="operate">
      <div class="operate_content">
        <div class="operate_item" v-for="item in healthyList1">
          <div class="operate_top">
            <img :src="item.src" alt="">
          </div>
          <div class="operate_bottom">
            <div class="btm_info">{{item.info}}</div>
            <div class="btm_tag" v-for="tag in item.tag">{{tag}}</div>
          </div>
        </div>
      </div>
      <div class="operate_content">
        <div class="operate_item" v-for="item in healthyList2">
          <div class="operate_top">
            <img :src="item.src" alt="">
          </div>
          <div class="operate_bottom">
            <div class="btm_info">{{item.info}}</div>
            <div class="btm_tag" v-for="tag in item.tag">{{tag}}</div>
          </div>
        </div>
      </div>
      <div class="operate_footer flex_row">
        <div class="operate_item" v-for="item in operateList">
          <img :src="item.src" alt="">
          <div class="operate_info">{{item.info}}</div>
        </div>
      </div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column operate_title">
        <span class="sys_summary">智慧视光中心业务范围案例</span>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="sys_content">
        <div class="sys_item" v-for="item in sysList">
          <div class="sys_top">
            <img :src="item.src" alt="">
          </div>
          <div class="sys_bottom">
            <div class="btm_title">{{item.title}}</div>
            <div class="btm_info" :class="info.tag==2?'btm_tag':''" v-for="info in item.info">{{info.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import bottom from "@/components/pc/bottom";
export default {
  name: 'Solution',
  components: {
    bottom
  },
  data() {
    return {
      list: [],
      operateList: [],
      healthyList1: [],
      healthyList2: [],
      sysList: []
    }
  },
  created() {
    let list = ['眼镜店','视光中心','门诊','医院','互联网医院'];
    let operateList = [
      {
        src: 'https://ow.visumall.com/public/img/solution_small1.png',
        info: '远程诊疗'
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_small2.png',
        info: '人工智能'
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_small3.png',
        info: '运营系统'
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_small4.png',
        info: 'ERP CRM'
      }];
    let healthyList1 = [
      {
        src: 'https://ow.visumall.com/public/img/solution_big1.png',
        info: '预约',
        tag: ['官网', 'APP', '公众号', '挂号机']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big2.png',
        info: '挂号',
        tag: ['官网', '接诊台', '公众号', '挂号机']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big3.png',
        info: '问诊',
        tag: ['APP', '医护', '公众号']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big4.png',
        info: '检查',
        tag: ['技师', '医师', '远程辅助']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big5.png',
        info: '处方',
        tag: ['AI', '医师', '远程辅助']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big6.png',
        info: '配镜',
        tag: ['技师', 'AI', '远程辅助']
      }
    ];
    let healthyList2 = [
      {
        src: 'https://ow.visumall.com/public/img/solution_big7.png',
        info: '加工',
        tag: ['车房', '加工室', '远程在线']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big8.png',
        info: '交付',
        tag: ['快递', '取镜处', '在线支付']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big9.png',
        info: '支付',
        tag: ['APP', '收银台', '公众号']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big10.png',
        info: '交互',
        tag: ['电话', '短信', '公众号', '远程辅助']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big11.png',
        info: '管理',
        tag: ['AI', '病历', '小程序', '远程辅助']
      },
      {
        src: 'https://ow.visumall.com/public/img/solution_big12.png',
        info: '复查',
        tag: ['AI', '医师', '远程辅助']
      },
    ];
    let sysList = [
      {
        src: 'https://ow.visumall.com/public/img/operation_system_1.png',
        title: '检查分诊',
        info: [
          {
            content: '校园筛查',
            tag: 1
          },
          {
            content: '社区公益',
            tag: 1
          },
          {
            content: '在线咨询',
            tag: 1
          },
          {
            content: '预约挂号',
            tag: 1
          },
          {
            content: '门诊检查',
            tag: 1
          },
          {
            content: '分诊患教',
            tag: 2
          },
          {
            content: '远程问诊',
            tag: 2
          },


        ]
      },
      {
        src: 'https://ow.visumall.com/public/img/operation_system_2.png',
        title: '屈光验配',
        info: [
          {
            content: '角膜接触镜',
            tag: 1
          },
          {
            content: '功能型验配',
            tag: 1
          },
          {
            content: '个性化定制',
            tag: 1
          },
          {
            content: '治疗型验配',
            tag: 1
          },
          {
            content: '术后验配',
            tag: 1
          },
          {
            content: '近视防控',
            tag: 2
          },
          {
            content: '远程处方',
            tag: 2
          },

        ]
      },
      {
        src: 'https://ow.visumall.com/public/img/operation_system_3.png',
        title: '视觉训练',
        info: [
          {
            content: '视功能训练',
            tag: 2
          },
          {
            content: '低视力训练',
            tag: 1
          },
          {
            content: '斜弱视训练',
            tag: 1
          },
          {
            content: '术后恢复训练',
            tag: 1
          },
          {
            content: '远程辅导训练',
            tag: 2
          },
          {
            content: '（器械/工具/VR/AR/3D)',
            tag: 1
          }
        ]
      },
      {
        src: 'https://ow.visumall.com/public/img/operation_system_4.png',
        title: '慢病康复',
        info: [
          {
            content: '干眼诊疗',
            tag: 2
          },
          {
            content: '康复训练',
            tag: 1
          },
          {
            content: '眼科术后',
            tag: 1
          },
          {
            content: '屈光手术后',
            tag: 1
          },
          {
            content: '功能重建训练',
            tag: 2
          },
          {
            content: '斜弱视术后',
            tag: 1
          },
          {
            content: '辅助训练',
            tag: 1
          }
        ]
      },
      {
        src: 'https://ow.visumall.com/public/img/operation_system_5.png',
        title: '健康管理',
        info: [
          {
            content: '健康档案',
            tag: 1
          },
          {
            content: '近视预防',
            tag: 2
          },
          {
            content: '眼病预警',
            tag: 1
          },
          {
            content: '常规体检',
            tag: 1
          },
          {
            content: '场景检测',
            tag: 1
          },
          {
            content: '行为管理',
            tag: 1
          },
          {
            content: '慢病监护',
            tag: 2
          }
        ]
      },
      {
        src: 'https://ow.visumall.com/public/img/operation_system_6.png',
        title: '预约转诊',
        info: [
          {
            content: '高端手术',
            tag: 1
          },
          {
            content: '预约挂号',
            tag: 1
          },
          {
            content: '术前患教',
            tag: 1
          },
          {
            content: '处置建议',
            tag: 1
          },
          {
            content: '数据共享',
            tag: 1
          },
          {
            content: '术后管理',
            tag: 2
          },
          {
            content: '复查管理',
            tag: 2
          },


        ]
      }
    ]
    this.operateList = operateList;
    this.healthyList1 = healthyList1;
    this.healthyList2 = healthyList2;
    this.sysList = sysList;
    this.list = list
  },
}
</script>

<style scoped lang="scss">
.Solution {
  .content1 {
    margin: 0.4rem 0 1.5rem;
  }
  .content {
    //margin: 85px 0;
    .solution_main {
      margin: 0.85rem 0 0;
      width: 100%;
      img {
        width: 100%;
      }
    }
    .solution_footer {
      margin: 0.18rem 0 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .solution_item {
        display: flex;
        justify-content: center;
        align-items: center;
        .item {
          border: 0.04rem solid #68BDEE;
          border-radius: 0.05rem;
          padding: 0.1rem 0.15rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .solution_title {
            font-size: 0.25rem;
          }
        }
        .solution_line {
          display: flex;
          align-items: center;
          position: relative;
          span {
            position: absolute;
            display: inline-block;
            width: 0.14rem;
            height: 0.14rem;
            border: 0.04rem solid #68BDEE;
            background: #FFFFFF;
            border-radius: 50%;
          }
          .left {
            left: -0.12rem;
          }
          .right {
            right: -0.12rem;
          }
          .line {
            //width: 0.9rem;
            width: 14vw;
            height: 0.04rem;
            background: #68BDEE;
          }
        }
      }
      .solution_item:last-child .solution_line {
        display: none;
      }
    }
  }

  .operate_back {
    position: relative;
    img {
      opacity: 0.3;
      position: absolute;
      left: 50%;
      transform: translate(-50%,0);
      width: 100%;
      z-index: -1;
    }
  }
  .operate {
    .operate_content {
      margin-top: 0.5rem;
      display: flex;
      .operate_item {
        flex: 1;
        .operate_top {
          width: 100%;
          img {
            width: 85%;
          }
        }
        .operate_bottom {
          margin-top: 0.28rem;
          .btm_info {
            font-weight: bold;
            margin-bottom: 0.13rem;
            font-size: 0.3rem;
          }
          .btm_tag {
            margin-bottom: 0.07rem;
            font-size: 0.18rem;
            //color: #004BBB;
          }
        }
      }
    }

    .operate_footer {
      margin: 0.4rem 0 1rem;
      .operate_item {
        width: 20%;
        img {
          width: 90%;
        }
        .operate_info {
          margin: 0.17rem 0 0;
          font-size: 0.3rem;
          font-weight: bold;
        }
      }
    }
  }

  .system {
    .operate_title {
      .operate_summary {
        font-weight: bold;
        font-size: 0.3rem;
      }
    }
    .sys_back {
      position: relative;
      width: 100%;
      //height: 100%;
      img {
        position: absolute;
        width: 100%;
        //height: auto;
        height: 100%;
        left: 50%;
        transform: translate(-50%,-5%);
        opacity: 0.3;
        z-index: -1;
      }
    }
    .sys_title {
      .sys_summary {
        display: inline-block;
        text-align: center;
        font-weight: bold;
        font-size: 0.3rem;
      }

    }
    .sys_content {
      margin-top: 0.4rem;
      margin-bottom: 0.8rem;
      display: flex;
      .sys_item {
        flex: 1;
        .sys_top {
          width: 100%;
          padding: 0.14rem 0;
          background: rgba(175,231,245,0.33);

          img {
            width: 85%;
          }
        }
        .sys_bottom {
          .btm_title {
            margin: 0.37rem 0 0.14rem;
            font-size: 0.3rem;
            font-weight: bold;
          }
          .btm_info {
            margin-bottom: 0.07rem;
            font-size: 0.18rem;
          }
          .btm_tag {
            font-size: 0.18rem;
            //color: #FF0000;
          }
        }
      }
    }

  }

}
</style>
